import { useEffect, useState } from "react";

interface LoadingScreenProps {
  onLoadComplete: () => void;
}

export const LoadingScreen = ({ onLoadComplete }: LoadingScreenProps) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(onLoadComplete, 500);
    }, 3500);

    return () => clearTimeout(timer);
  }, [onLoadComplete]);

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-background transition-opacity duration-500 ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
    >
      <div className="animate-fade-in flex flex-col items-center justify-center w-full relative">
        <h1 className="font-serif text-5xl md:text-7xl tracking-[0.2em] text-foreground mb-6 text-center" style={{ fontWeight: 300, fontSynthesis: 'none', paddingLeft: '0.2em' }}>
          SIAM HORIZON
        </h1>
        <div className="flex items-center justify-center mt-2">
          <div 
            className="h-[1px] origin-right loading-line-left"
            style={{ 
              width: '175px',
              background: 'linear-gradient(to left, hsl(var(--primary) / 0.6) 75%, transparent 100%)'
            }}
          />
          <div 
            className="h-[1px] origin-left loading-line-right"
            style={{ 
              width: '175px',
              background: 'linear-gradient(to right, hsl(var(--primary) / 0.6) 75%, transparent 100%)'
            }}
          />
        </div>
        <style>{`
          .loading-line-left {
            transform: scaleX(0);
            animation: loadingExpandLeft 2s ease-out 0.5s forwards;
          }
          .loading-line-right {
            transform: scaleX(0);
            animation: loadingExpandRight 2s ease-out 0.5s forwards;
          }
          @keyframes loadingExpandLeft {
            from { transform: scaleX(0); }
            to { transform: scaleX(1); }
          }
          @keyframes loadingExpandRight {
            from { transform: scaleX(0); }
            to { transform: scaleX(1); }
          }
          @media (min-width: 768px) {
            .loading-line-left,
            .loading-line-right {
              width: 290px !important;
            }
          }
        `}</style>
        <p className="font-serif text-4xl md:text-5xl tracking-wider text-muted-foreground text-center mt-6 animate-fade-in animation-delay-500" style={{ fontWeight: 300, fontSynthesis: 'none' }}>
          HUA HIN
        </p>
      </div>
      <div className="absolute bottom-12 w-16 h-0.5 bg-primary/20 animate-pulse" />
    </div>
  );
};
